import React, { useEffect, useRef, useState } from 'react';
import { Button, Popconfirm, Space, Tooltip } from 'antd';
import { IPageData, IPageProps } from '../../../interfaces/page-data';
import HTTPService from '../../../utils/makerequest';
import { Toast } from 'primereact/toast';
import MUIDatagrid, { IMUIDataGridColumns } from '../../../AltisComponent/MUIDataGrid';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { ITemplates } from '../../../interfaces/ITemplatesData';
import { IAuthentication, UserRole } from '../../../interfaces/authentication';
import { StateLoader } from '../../../redux/StateLoader';
import { useTranslation } from 'react-i18next';
import AddBoxIcon from '@mui/icons-material/AddBox';

const TemplatesPage: React.FunctionComponent<IPageProps> = (props) => {
  const { onSetPage } = props;
  const [templatesData, setTemplatesData] = useState<ITemplates>({});
  const { t } = useTranslation();
  const toast = useRef<any>(null);
  const userInfo: IAuthentication = (new StateLoader()).loadAuthState();
  const pageData: IPageData = {
    title: t('Templates'),
    loaded: true,
  };
  const dataGridRef = useRef<any>(null);

  useEffect(() => {
    onSetPage(pageData);
    dataGridRef.current.GetAllData();
  }, []);

  const TemplatesData = (e?) => {
    const filters = e?.filters;
    const body = {
      sortColumn: e?.sortField,
      sortOrder: e?.sortOrder || 'asc',
      page: e?.page,
      pageSize: e?.pageSize,
      templateName: filters?.templateName,
      templateCode: filters?.templatesCode,
      companyName: filters?.companyName,
      companyId: e?.companyId,
      programingLanguage: e?.programingLanguage,
    };
    HTTPService.POST(`/Template/filters`, body).then((response) => {
      if (!response.data) {
        return;
      }
      if (response.status === 200) {
        setTemplatesData(response.data);
      } else {
        toast.current?.show({ severity: 'error', summary: 'errors', detail: t(response.data), life: 3000 });
      }
    })
      .catch((exception) => console.error(exception));
  };

  const DeleteTemplates = (id) => {
    HTTPService.DELETE(`/Template/deleteTemplate?Id=${id}`).then((response) => {
      if (response.status === 200) {
        toast.current?.show({ severity: 'success', summary: t('successful'), detail: t(response.data), life: 3000 });
        dataGridRef.current.GetAllData();
      } else {
        toast.current?.show({ severity: 'error', summary: t('mistake'), detail: t(response.data), life: 3000 });
      }
    });
  };

  const isAltisAdmin = userInfo?.role === UserRole.AltisAdmin;

  const columnsByUsers: IMUIDataGridColumns[] = [
    ...(userInfo.role == UserRole.AltisAdmin ? [{
      title: t('Company Name'),
      key: 'companyName',
      isSorting: true,
      placeHolder: t('Company Name'),
    }] : []),
    {
      title: t('Templates Name'),
      key: 'templateName',
      isSorting: true,
      align: 'center',
      headerAlign: 'center',
      placeHolder: t('Templates Name'),
    },
    {
      title: t('Templates Code'),
      key: 'templatesCode',
      isSorting: true,
      align: 'center',
      headerAlign: 'center',
      placeHolder: t('Templates Code'),
    },
    {
      title: t('Operations'),
      key: 'operations',
      hideColumnMenu: true,
      placeHolder: t('Operations'),
      align: 'center',
      headerAlign: 'center',
      render: (order, record) => (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center',marginTop:10, gap: '8px' }}>
          <Space size={8}>
            <Popconfirm
              title={t('Are you sure you want to delete this template?')}
              onConfirm={() => {
                DeleteTemplates(record.templateId);
              }}
              okText={t('Yes')}
              cancelText={t('No')}>
              <Tooltip title={t('delete')}>
                <Button
                  size='small'
                  icon={<DeleteOutlined />}
                  style={{ display: userInfo.role === UserRole.Sayman ? 'none' : 'block', width: '60px', borderRadius: '70px' }}
                  onClick={(e) => {
                    e.stopPropagation();
                  }}>
                </Button>
              </Tooltip>
            </Popconfirm>
            <Tooltip title={t('update')}>
              <Button
                size='small'
                icon={<EditOutlined />}
                style={{ display: userInfo.role === UserRole.Sayman ? 'none' : 'block', width: '60px', borderRadius: '70px' }}
                onClick={() => {
                  window.location.replace('/admin/update-templates/' + record.templateId);
                }}>
              </Button>
            </Tooltip>
          </Space>
        </div>
      ),
    },
  ];

  return (
    <>
      <Toast ref={toast} />
      <div className='row'>
        <div className='col-md-4 mb-3' style={{ display: userInfo.role === UserRole.Sayman ? 'none' : 'block' }}>
          <Tooltip title={t('Add New Templates')}>
            <Button
              type="primary"
              shape="round"
              style={{
                width: 'auto',
                height: 64,
                backgroundColor: 'transparent',
                color: '#1890ff',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                marginLeft: '10px',
                padding: 0,
                border: 'none',
                transition: 'all 0.3s ease',
                cursor: 'pointer'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'scale(1.05)';
                e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.1)';
                e.currentTarget.style.color = '#40a9ff';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'scale(1)';
                e.currentTarget.style.boxShadow = 'none';
                e.currentTarget.style.color = '#1890ff';
              }}
              size="middle"
              onClick={() => window.location.replace('/admin/add-templates')}
            >
              <AddBoxIcon style={{ fontSize: 24 }} />
              <span style={{ fontSize: '12px', marginTop: '4px' }}>{t('Add New Templates')}</span>
            </Button>
          </Tooltip>
        </div>
      </div>
      <div className='row'>
        <div className='col-md-12'>
          <div className='table-container'>
            <MUIDatagrid
              ref={dataGridRef}
              data={templatesData.data}
              total={templatesData.count}
              columns={columnsByUsers}
              filterMode='server'
              onChange={TemplatesData}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default TemplatesPage;
